import {
    JsonOpcodeStep, LLMStep, RAGStep, APIStep, MemoryStep,
    ChooseStep, SubflowStep, ToolStep, ParallelStep, CallStep, FlowDefinition
} from 'builders/builderOpcode/jsonMode/types';
import {
 OELContext
} from './components/OELCodeEditor';
import V2StepLLM from './steps/V2StepLLM';
import V2StepRAG from './steps/V2StepRAG';
import V2StepAPI from './steps/V2StepAPI';
import V2StepMemory from './steps/V2StepMemory';
import V2StepChoose from './steps/V2StepChoose';
import V2StepSubflow from './steps/V2StepSubflow';
import V2StepTool from './steps/V2StepTool';
import V2StepParallel from './steps/V2StepParallel';
import V2StepCall from './steps/V2StepCall';

const V2StepDispatcher = ({
    step,
    onStepChange,
    definitions = [],
    flows = [],
    oelContext,
}: {
    step: JsonOpcodeStep;
    onStepChange: (step: JsonOpcodeStep) => void;
    definitions?: JsonOpcodeStep[];
    flows?: FlowDefinition[];
    oelContext?: OELContext;
}) => {
    const ctx: OELContext = oelContext || {
 inputs: [],
previousStepIds: []
};

    switch (step.kind) {
        case 'llm':
            return (
                <V2StepLLM
                    step={step as LLMStep}
                    onStepChange={onStepChange as (step: LLMStep) => void}
                    oelContext={ctx}
                />
            );
        case 'rag':
            return (
                <V2StepRAG
                    step={step as RAGStep}
                    onStepChange={onStepChange as (step: RAGStep) => void}
                    oelContext={ctx}
                />
            );
        case 'api':
            return (
                <V2StepAPI
                    step={step as APIStep}
                    onStepChange={onStepChange as (step: APIStep) => void}
                    oelContext={ctx}
                />
            );
        case 'memory':
            return (
                <V2StepMemory
                    step={step as MemoryStep}
                    onStepChange={onStepChange as (step: MemoryStep) => void}
                    oelContext={ctx}
                />
            );
        case 'choose':
            return (
                <V2StepChoose
                    step={step as ChooseStep}
                    onStepChange={onStepChange as (step: ChooseStep) => void}
                    definitions={definitions}
                    flows={flows}
                    oelContext={ctx}
                />
            );
        case 'subflow':
            return (
                <V2StepSubflow
                    step={step as SubflowStep}
                    onStepChange={onStepChange as (step: SubflowStep) => void}
                    flows={flows}
                    oelContext={ctx}
                />
            );
        case 'tool':
            return (
                <V2StepTool
                    step={step as ToolStep}
                    onStepChange={onStepChange as (step: ToolStep) => void}
                    oelContext={ctx}
                />
            );
        case 'parallel':
            return (
                <V2StepParallel
                    step={step as ParallelStep}
                    onStepChange={onStepChange as (step: ParallelStep) => void}
                    definitions={definitions}
                    flows={flows}
                    oelContext={ctx}
                />
            );
        case 'call':
            return (
                <V2StepCall
                    step={step as CallStep}
                    onStepChange={onStepChange as (step: CallStep) => void}
                    definitions={definitions}
                    oelContext={ctx}
                />
            );
        default:
            return (
                <div className="p-3 text-sm text-muted-foreground">
                    Unknown step kind: {(step as any).kind}
                </div>
            );
    }
};

export default V2StepDispatcher;
